import { watch } from 'vue'
import type { Router } from 'vue-router'
import type { useAuthStore } from '@/stores/auth.store'

/**
 * The no-seat flag is raised by a response (the fetch watch in `lib/account-access.ts`), not by
 * a navigation, so the auth guard alone acts only on the NEXT navigation. Move the member now.
 */
export function installSeatRedirect(router: Router, authStore: ReturnType<typeof useAuthStore>) {
  watch(
    () => authStore.seatRequired,
    seatRequired => {
      if (seatRequired)
        void router.replace({ path: router.currentRoute.value.fullPath, force: true })
    }
  )
}
